export default "__VITE_ASSET__CMq5ZcxI__"